import { API_endpoints } from "../config"; 

export const checkEmail = async (email: string): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.EmailCheck , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler bei der Überprüfung der E-Mail:", error);
        throw new Error("Fehler bei der Überprüfung der E-Mail.");
    }
};